module.exports = __webpack_public_path__ + "img/mgh-kanazawa@2x.566070f7.jpg";